<template>
    <form class="bbrc-advanced-search" v-on:submit.prevent="handleSubmit">
        <div class="bbrc-advanced-search-header">
            <div class="bbrc-advanced-search-title">
                <span>Advanced search</span>
            </div>
            <div class="bbrc-advanced-search-sub-title">
                <span>powered by Google</span>
            </div>
        </div>

        <nav class="bbrc-advanced-search__tabs">
            <a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'search' }"
               v-on:click="switchTab('search')">
                <span>Search</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>
            <a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'images' }"
               v-on:click="switchTab('images')">
                <span>Images</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>
            <a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'videos' }"
               v-on:click="switchTab('videos')">
                <span>Videos</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>
            <a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'news' }"
               v-on:click="switchTab('news')">
                <span>News</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>
            <a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'books' }"
               v-on:click="switchTab('books')">
                <span>Books</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>
            <!--<a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'blogs' }"
               v-on:click="switchTab('blogs')"
            >
                <span>Blogs</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>-->
            <a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'maps' }"
               v-on:click="switchTab('maps')">
                <span>Maps</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>
            <a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'finance' }"
               v-on:click="switchTab('finance')">
                <span>Finance</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>
            <a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'patents' }"
               v-on:click="switchTab('patents')">
                <span>Patents</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>
            <a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'flights' }"
               v-on:click="switchTab('flights')">
                <span>Flights</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>
            <a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'scholar' }"
               v-on:click="switchTab('scholar')">
                <span>Scholar</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>
            <a class="bbrc-advanced-search__tab"
               v-bind:class="{ 'is-active' : activeTab == 'shopping' }"
               v-on:click="switchTab('shopping')">
                <span>Shopping</span>
                <svg viewBox="0 0 13 6"></svg>
            </a>
        </nav>

        <div class="bbrc-advanced-search__container">
            <button class="btn is-primary bbrc-advanced-search__send-btn">{{ __('Go') }}</button>
            <input class="bbrc-advanced-search__control" v-bind:placeholder="searchPlaceholder" v-model="search" />
            <div v-if="activeTab == 'search' && activeTags.length > 0" style="margin: 5px;">
                <vc-tag v-for="(tag, index) in activeTags" :dark="tag.dark" :color="tag.color" @close="onTagRemoved(index)" closable :key="`${index}-1`">{{ tag.name }}</vc-tag>
                <a v-on:click="handleReset()" class="bbrc-clear-all">{{ __('Clear all') }}</a>
            </div>
        </div>

        <div class="advanced-search__options" v-if="activeTab == 'search'">
            <nav class="advanced-search__options__tabs">
                <a class="advanced-search__options__tab"
                   v-bind:class="{ 'is-active' : activeOptionTab == 'country' }"
                   v-on:click="switchOptionTab('country')">
                    <span class="is-hidden-mobile">{{ __('Search') }} </span>{{ __('by country') }}
                </a>
                <a class="advanced-search__options__tab"
                   v-bind:class="{ 'is-active' : activeOptionTab == 'language' }"
                   v-on:click="switchOptionTab('language')">
                    <span class="is-hidden-mobile">{{ __('Search') }} </span>{{ __('by language') }}
                </a>
                <a class="advanced-search__options__tab"
                   v-bind:class="{ 'is-active' : activeOptionTab == 'filetype' }"
                   v-on:click="switchOptionTab('filetype')">
                    <span class="is-hidden-mobile">{{ __('Search') }} </span>{{ __('by file type') }}
                </a>
                <a class="advanced-search__options__tab"
                   v-bind:class="{ 'is-active' : activeOptionTab == 'dates' }"
                   v-on:click="switchOptionTab('dates')">
                    <span class="is-hidden-mobile">{{ __('Search') }} </span>{{ __('by dates') }}
                </a>
                <a class="advanced-search__options__tab"
                   v-bind:class="{ 'is-active' : activeOptionTab == 'site' }"
                   v-on:click="switchOptionTab('site')">
                    <span class="is-hidden-mobile">{{ __('Search') }} </span>{{ __('by site') }}
                </a>
                <a class="advanced-search__options__tab"
                   v-bind:class="{ 'is-active' : activeOptionTab == 'words' }"
                   v-on:click="switchOptionTab('words')">
                    <span class="is-hidden-mobile">{{ __('Search') }} </span>{{ __('by words') }}
                </a>
            </nav>

            <div class="advanced-search__options__fields advanced-search__options__fields--country"
                 v-show="activeOptionTab == 'country'">
                <div class="form__group" style="margin-bottom: 0px;">
                    <selector v-bind:has-autocomplete="false"
                              v-bind:is-inline="true"
                              v-bind:multiple-select="true"
                              v-bind:placeholder="__('Select country')"
                              v-bind:values="countries"
                              v-model="country"
                              v-on:input="changedAdvancedSearchOptions" />
                </div>
            </div>
            <div class="advanced-search__options__fields advanced-search__options__fields--language"
                 v-show="activeOptionTab == 'language'">
                <div class="form__group">
                    <selector v-bind:has-autocomplete="false"
                              v-bind:is-inline="true"
                              v-bind:multiple-select="true"
                              v-bind:placeholder="__('Select language')"
                              v-bind:values="languages"
                              v-model="language"
                              v-on:input="changedAdvancedSearchOptions" />
                </div>
            </div>
            <div class="advanced-search__options__fields advanced-search__options__fields--filetype"
                 v-show="activeOptionTab == 'filetype'">
                <div class="form__group">
                    <nav class="bbrc-advanced-search__tabs small__tabs">
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'popular' }"
                           v-on:click="switchFileTypeTab('popular')">
                            <span>Popular</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'audio' }"
                           v-on:click="switchFileTypeTab('audio')">
                            <span>Audio</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'video' }"
                           v-on:click="switchFileTypeTab('video')">
                            <span>Video</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'image' }"
                           v-on:click="switchFileTypeTab('image')">
                            <span>Image</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'text' }"
                           v-on:click="switchFileTypeTab('text')">
                            <span>Text</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'presentation' }"
                           v-on:click="switchFileTypeTab('presentation')">
                            <span>Presentation</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'spreadsheat' }"
                           v-on:click="switchFileTypeTab('spreadsheat')">
                            <span>Spreadsheat</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'font' }"
                           v-on:click="switchFileTypeTab('font')">
                            <span>Font</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'compressed' }"
                           v-on:click="switchFileTypeTab('compressed')">
                            <span>Compressed</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'media' }"
                           v-on:click="switchFileTypeTab('media')">
                            <span>Disk & Media</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'data' }"
                           v-on:click="switchFileTypeTab('data')">
                            <span>Data & Database</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'internet' }"
                           v-on:click="switchFileTypeTab('internet')">
                            <span>Internet related</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'programming' }"
                           v-on:click="switchFileTypeTab('programming')">
                            <span>Programming</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'system' }"
                           v-on:click="switchFileTypeTab('system')">
                            <span>System related</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                        <a class="bbrc-advanced-search__tab small__tab"
                           v-bind:class="{ 'is-active' : activeFileTypeTab == 'executable' }"
                           v-on:click="switchFileTypeTab('executable')">
                            <span>Executable</span>
                            <svg viewBox="0 0 13 6"></svg>
                        </a>
                    </nav>

                    <div v-if="activeFileTypeTab == 'popular'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.popular"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'audio'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.audio"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'video'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.video"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'image'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.image"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'text'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.text"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'presentation'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.presentation"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'spreadsheet'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.spreadsheet"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'font'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.font"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'compressed'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.compressed"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'media'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.media"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'data'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.data"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'internet'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.internet"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'programming'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.programming"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'system'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.system"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>
                    <div v-if="activeFileTypeTab == 'executable'">
                        <selector v-bind:is-inline="true"
                                  v-bind:multiple-select="true"
                                  v-bind:values="filetypes.executable"
                                  v-bind:placeholder="__('Select file type')"
                                  v-model="filetype"
                                  v-on:input="changedAdvancedSearchOptions" />
                    </div>

                    <div class="form__group has-margin-t30">
                        Custom filetypes:
                        <input class="form__control" placeholder="Filetype" type="text"
                               v-model="filetypeSearch"
                               v-on:blur="changedAdvancedSearchOptions" />
                        <small class="has-margin-t5 is-block">Use comma (,) to separate two or more filetypes</small>
                    </div>
                </div>
            </div>
            <div class="advanced-search__options__fields advanced-search__options__fields--dates"
                 v-show="activeOptionTab == 'dates'">
                <div class="form__group">
                    <selector v-bind:values="updatedAtValues"
                              v-bind:placeholder="__('Last update')"
                              v-model="updatedAt"
                              v-on:input="changedAdvancedSearchOptions"
                              v-bind:has-autocomplete="false"
                              v-bind:is-inline="true"
                              v-bind:multiple-select="false"
                              v-bind:control-type="'radio'" />
                </div>
            </div>
            <div class="advanced-search__options__fields advanced-search__options__fields--site"
                 v-show="activeOptionTab == 'site'">
                <div class="form__group">
                    <input class="form__control" type="text"
                           v-bind:placeholder="__('URL')"
                           v-model="site"
                           v-on:change="changedAdvancedSearchOptions" />
                    <small class="has-margin-t5 is-block">Search one site (like wikipedia.org ) or limit your results to a domain like .edu, .org or .gov</small>
                </div>
            </div>
            <div class="advanced-search__options__fields advanced-search__options__fields--words"
                 v-show="activeOptionTab == 'words'">
                <div class="form__group">
                    <label class="form__label" for="all-these-words">{{ __('All these words') }}</label>
                    <input class="form__control" id="all-these-words" type="text" placeholder="Type the important words"
                           v-model="allTheseWords"
                           v-on:change="changedAdvancedSearchOptions" />
                </div>
                <div class="form__group">
                    <label class="form__label" for="this-exact-phrase">{{ __('This exact word or phrase') }}</label>
                    <input class="form__control" id="this-exact-phrase" type="text" placeholder="Put exact words in quotes"
                           v-model="thisExactPhrase"
                           v-on:change="changedAdvancedSearchOptions" />
                </div>
                <div class="form__group">
                    <label class="form__label" for="any-of-these-words">{{ __('Any of these words') }}</label>
                    <input class="form__control" id="any-of-these-words" type="text" placeholder="Type OR between all the words you want:  miniature OR standard"
                           v-model="anyOfTheseWords"
                           v-on:change="changedAdvancedSearchOptions" />
                </div>
                <div class="form__group" style="margin-bottom: 10px;">
                    <label class="form__label" for="none-of-these-words">{{ __('None of these words') }}</label>
                    <input class="form__control" id="none-of-these-words" type="text" placeholder="Put a minus sign just before words that you don't want"
                           v-model="noneOfTheseWords"
                           v-on:change="changedAdvancedSearchOptions" />
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import selector from '../elements/Selector.vue';

    export default {
        name: 'BbrcAdvancedSearch',
        components: {
            selector
        },
        created: function () {
            this.init();
        },
        data: function () {
            return {
                activeOptionTab: 'country',
                activeFileTypeTab: 'popular',
                activeTab: 'search',
                allTheseWords: '',
                anyOfTheseWords: '',
                country: null,
                countries: [
                    { name: "Afghanistan", flag: true, icon: "flags/af.png", value: "af" },
                    { name: "Albania", flag: true, icon: "flags/al.png", value: "al" },
                    { name: "Algeria", flag: true, icon: "flags/dz.png", value: "dz" },
                    { name: "American Samoa", flag: true, icon: "flags/as.png", value: "as" },
                    { name: "Andorra", flag: true, icon: "flags/ad.png", value: "ad" },
                    { name: "Angola", flag: true, icon: "flags/ao.png", value: "ao" },
                    { name: "Anguilla", flag: true, icon: "flags/ai.png", value: "ai" },
                    { name: "Antarctica", flag: true, icon: "flags/aq.png", value: "aq" },
                    { name: "Antigua and Barbuda", flag: true, icon: "flags/ag.png", value: "ag" },
                    { name: "Argentina", flag: true, icon: "flags/ar.png", value: "ar" },
                    { name: "Armenia", flag: true, icon: "flags/am.png", value: "am" },
                    { name: "Aruba", flag: true, icon: "flags/aw.png", value: "aw" },
                    { name: "Australia", flag: true, icon: "flags/au.png", value: "au" },
                    { name: "Austria", flag: true, icon: "flags/at.png", value: "at" },
                    { name: "Azerbaijan", flag: true, icon: "flags/az.png", value: "az" },
                    { name: "Bahamas", flag: true, icon: "flags/bs.png", value: "bs" },
                    { name: "Bahrain", flag: true, icon: "flags/bh.png", value: "bh" },
                    { name: "Bangladesh", flag: true, icon: "flags/bd.png", value: "bd" },
                    { name: "Barbados", flag: true, icon: "flags/bb.png", value: "bb" },
                    { name: "Belarus", flag: true, icon: "flags/by.png", value: "by" },
                    { name: "Belgium", flag: true, icon: "flags/be.png", value: "be" },
                    { name: "Belize", flag: true, icon: "flags/bz.png", value: "bz" },
                    { name: "Benin", flag: true, icon: "flags/bj.png", value: "bj" },
                    { name: "Bermuda", flag: true, icon: "flags/bm.png", value: "bm" },
                    { name: "Bhutan", flag: true, icon: "flags/bt.png", value: "bt" },
                    { name: "Bolivia", flag: true, icon: "flags/bo.png", value: "bo" },
                    { name: "Bosnia and Herzegovina", flag: true, icon: "flags/ba.png", value: "ba" },
                    { name: "Botswana", flag: true, icon: "flags/bw.png", value: "bw" },
                    { name: "Bouvet Island", flag: true, icon: "flags/bv.png", value: "bv" },
                    { name: "Brazil", flag: true, icon: "flags/br.png", value: "br" },
                    { name: "British Indian Ocean Territory", flag: true, icon: "flags/io.png", value: "io" },
                    { name: "Brunei Darussalam", flag: true, icon: "flags/bn.png", value: "bn" },
                    { name: "Bulgaria", flag: true, icon: "flags/bg.png", value: "bg" },
                    { name: "Burkina Faso", flag: true, icon: "flags/bf.png", value: "bf" },
                    { name: "Burundi", flag: true, icon: "flags/bi.png", value: "bi" },
                    { name: "Cabo Verde", flag: true, icon: "flags/cv.png", value: "cv" },
                    { name: "Cambodia", flag: true, icon: "flags/kh.png", value: "kh" },
                    { name: "Cameroon", flag: true, icon: "flags/cm.png", value: "cm" },
                    { name: "Canada", flag: true, icon: "flags/ca.png", value: "ca" },
                    { name: "Cayman Islands", flag: true, icon: "flags/ky.png", value: "ky" },
                    { name: "Central African Republic", flag: true, icon: "flags/cf.png", value: "cf" },
                    { name: "Chad", flag: true, icon: "flags/td.png", value: "td" },
                    { name: "Chile", flag: true, icon: "flags/cl.png", value: "cl" },
                    { name: "China", flag: true, icon: "flags/cn.png", value: "cn" },
                    { name: "Christmas Island", flag: true, icon: "flags/cx.png", value: "cx" },
                    { name: "Cocos (Keeling) Islands", flag: true, icon: "flags/cc.png", value: "cc" },
                    { name: "Colombia", flag: true, icon: "flags/co.png", value: "co" },
                    { name: "Comoros", flag: true, icon: "flags/km.png", value: "km" },
                    { name: "Congo", flag: true, icon: "flags/cg.png", value: "cg" },
                    { name: "Congo, Democratic Republic of the", flag: true, icon: "flags/cd.png", value: "cd" },
                    { name: "Cook Islands", flag: true, icon: "flags/ck.png", value: "ck" },
                    { name: "Costa Rica", flag: true, icon: "flags/cr.png", value: "cr" },
                    { name: "Côte d'Ivoire", flag: true, icon: "flags/ci.png", value: "ci" },
                    { name: "Croatia", flag: true, icon: "flags/hr.png", value: "hr" },
                    { name: "Cuba", flag: true, icon: "flags/cu.png", value: "cu" },
                    { name: "Curaçao", flag: true, icon: "flags/cw.png", value: "cw" },
                    { name: "Cyprus", flag: true, icon: "flags/cy.png", value: "cy" },
                    { name: "Czechia", flag: true, icon: "flags/cz.png", value: "cz" },
                    { name: "Denmark", flag: true, icon: "flags/dk.png", value: "dk" },
                    { name: "Djibouti", flag: true, icon: "flags/dj.png", value: "dj" },
                    { name: "Dominica", flag: true, icon: "flags/dm.png", value: "dm" },
                    { name: "Dominican Republic", flag: true, icon: "flags/do.png", value: "do" },
                    { name: "Ecuador", flag: true, icon: "flags/ec.png", value: "ec" },
                    { name: "Egypt", flag: true, icon: "flags/eg.png", value: "eg" },
                    { name: "El Salvador", flag: true, icon: "flags/sv.png", value: "sv" },
                    { name: "Equatorial Guinea", flag: true, icon: "flags/gq.png", value: "gq" },
                    { name: "Eritrea", flag: true, icon: "flags/er.png", value: "er" },
                    { name: "Estonia", flag: true, icon: "flags/ee.png", value: "ee" },
                    { name: "Eswatini", flag: true, icon: "flags/sz.png", value: "sz" },
                    { name: "Ethiopia", flag: true, icon: "flags/et.png", value: "et" },
                    { name: "Falkland Islands (Malvinas)", flag: true, icon: "flags/fk.png", value: "fk" },
                    { name: "Faroe Islands", flag: true, icon: "flags/fo.png", value: "fo" },
                    { name: "Fiji", flag: true, icon: "flags/fj.png", value: "fj" },
                    { name: "Finland", flag: true, icon: "flags/fi.png", value: "fi" },
                    { name: "France", flag: true, icon: "flags/fr.png", value: "fr" },
                    { name: "French Guiana", flag: true, icon: "flags/gf.png", value: "gf" },
                    { name: "French Polynesia", flag: true, icon: "flags/pf.png", value: "pf" },
                    { name: "French Southern Territories", flag: true, icon: "flags/tf.png", value: "tf" },
                    { name: "Gabon", flag: true, icon: "flags/ga.png", value: "ga" },
                    { name: "Gambia", flag: true, icon: "flags/gm.png", value: "gm" },
                    { name: "Georgia", flag: true, icon: "flags/ge.png", value: "ge" },
                    { name: "Germany", flag: true, icon: "flags/de.png", value: "de" },
                    { name: "Ghana", flag: true, icon: "flags/gh.png", value: "gh" },
                    { name: "Gibraltar", flag: true, icon: "flags/gi.png", value: "gi" },
                    { name: "Greece", flag: true, icon: "flags/gr.png", value: "gr" },
                    { name: "Greenland", flag: true, icon: "flags/gl.png", value: "gl" },
                    { name: "Grenada", flag: true, icon: "flags/gd.png", value: "gd" },
                    { name: "Guadeloupe", flag: true, icon: "flags/gp.png", value: "gp" },
                    { name: "Guam", flag: true, icon: "flags/gu.png", value: "gu" },
                    { name: "Guatemala", flag: true, icon: "flags/gt.png", value: "gt" },
                    { name: "Guernsey", flag: true, icon: "flags/gg.png", value: "gg" },
                    { name: "Guinea", flag: true, icon: "flags/gn.png", value: "gn" },
                    { name: "Guinea-Bissau", flag: true, icon: "flags/gw.png", value: "gw" },
                    { name: "Guyana", flag: true, icon: "flags/gy.png", value: "gy" },
                    { name: "Haiti", flag: true, icon: "flags/ht.png", value: "ht" },
                    { name: "Heard Island and McDonald Islands", flag: true, icon: "flags/hm.png", value: "hm" },
                    { name: "Holy See", flag: true, icon: "flags/va.png", value: "va" },
                    { name: "Honduras", flag: true, icon: "flags/hn.png", value: "hn" },
                    { name: "Hong Kong", flag: true, icon: "flags/hk.png", value: "hk" },
                    { name: "Hungary", flag: true, icon: "flags/hu.png", value: "hu" },
                    { name: "Iceland", flag: true, icon: "flags/is.png", value: "is" },
                    { name: "India", flag: true, icon: "flags/in.png", value: "in" },
                    { name: "Indonesia", flag: true, icon: "flags/id.png", value: "id" },
                    { name: "Iran, Islamic Republic of", flag: true, icon: "flags/ir.png", value: "ir" },
                    { name: "Iraq", flag: true, icon: "flags/iq.png", value: "iq" },
                    { name: "Ireland", flag: true, icon: "flags/ie.png", value: "ie" },
                    { name: "Israel", flag: true, icon: "flags/il.png", value: "il" },
                    { name: "Italy", flag: true, icon: "flags/it.png", value: "it" },
                    { name: "Jamaica", flag: true, icon: "flags/jm.png", value: "jm" },
                    { name: "Japan", flag: true, icon: "flags/jp.png", value: "jp" },
                    { name: "Jordan", flag: true, icon: "flags/jo.png", value: "jo" },
                    { name: "Kazakhstan", flag: true, icon: "flags/kz.png", value: "kz" },
                    { name: "Kenya", flag: true, icon: "flags/ke.png", value: "ke" },
                    { name: "Kiribati", flag: true, icon: "flags/ki.png", value: "ki" },
                    { name: "Korea, Democratic People's Republic of", flag: true, icon: "flags/kp.png", value: "kp" },
                    { name: "Korea, Republic of", flag: true, icon: "flags/kr.png", value: "kr" },
                    { name: "Kuwait", flag: true, icon: "flags/kw.png", value: "kw" },
                    { name: "Kyrgyzstan", flag: true, icon: "flags/kg.png", value: "kg" },
                    { name: "Lao People's Democratic Republic", flag: true, icon: "flags/la.png", value: "la" },
                    { name: "Latvia", flag: true, icon: "flags/lv.png", value: "lv" },
                    { name: "Lebanon", flag: true, icon: "flags/lb.png", value: "lb" },
                    { name: "Lesotho", flag: true, icon: "flags/ls.png", value: "ls" },
                    { name: "Liberia", flag: true, icon: "flags/lr.png", value: "lr" },
                    { name: "Libya", flag: true, icon: "flags/ly.png", value: "ly" },
                    { name: "Liechtenstein", flag: true, icon: "flags/li.png", value: "li" },
                    { name: "Lithuania", flag: true, icon: "flags/lt.png", value: "lt" },
                    { name: "Luxembourg", flag: true, icon: "flags/lu.png", value: "lu" },
                    { name: "Macao", flag: true, icon: "flags/mo.png", value: "mo" },
                    { name: "Macedonia, the former Yugoslav Republic of", flag: true, icon: "flags/mk.png", value: "mk" },
                    { name: "Madagascar", flag: true, icon: "flags/mg.png", value: "mg" },
                    { name: "Malawi", flag: true, icon: "flags/mw.png", value: "mw" },
                    { name: "Malaysia", flag: true, icon: "flags/my.png", value: "my" },
                    { name: "Maldives", flag: true, icon: "flags/mv.png", value: "mv" },
                    { name: "Mali", flag: true, icon: "flags/ml.png", value: "ml" },
                    { name: "Malta", flag: true, icon: "flags/mt.png", value: "mt" },
                    { name: "Marshall Islands", flag: true, icon: "flags/mh.png", value: "mh" },
                    { name: "Martinique", flag: true, icon: "flags/mq.png", value: "mq" },
                    { name: "Mauritania", flag: true, icon: "flags/mr.png", value: "mr" },
                    { name: "Mauritius", flag: true, icon: "flags/mu.png", value: "mu" },
                    { name: "Mayotte", flag: true, icon: "flags/yt.png", value: "yt" },
                    { name: "Mexico", flag: true, icon: "flags/mx.png", value: "mx" },
                    { name: "Micronesia, Federated States of", flag: true, icon: "flags/fm.png", value: "fm" },
                    { name: "Moldova, Republic of", flag: true, icon: "flags/md.png", value: "md" },
                    { name: "Monaco", flag: true, icon: "flags/mc.png", value: "mc" },
                    { name: "Mongolia", flag: true, icon: "flags/mn.png", value: "mn" },
                    { name: "Montenegro", flag: true, icon: "flags/me.png", value: "me" },
                    { name: "Montserrat", flag: true, icon: "flags/ms.png", value: "ms" },
                    { name: "Morocco", flag: true, icon: "flags/ma.png", value: "ma" },
                    { name: "Mozambique", flag: true, icon: "flags/mz.png", value: "mz" },
                    { name: "Myanmar", flag: true, icon: "flags/mm.png", value: "mm" },
                    { name: "Namibia", flag: true, icon: "flags/na.png", value: "na" },
                    { name: "Nauru", flag: true, icon: "flags/nr.png", value: "nr" },
                    { name: "Nepal", flag: true, icon: "flags/np.png", value: "np" },
                    { name: "Netherlands", flag: true, icon: "flags/nl.png", value: "nl" },
                    { name: "New Caledonia", flag: true, icon: "flags/nc.png", value: "nc" },
                    { name: "New Zealand", flag: true, icon: "flags/nz.png", value: "nz" },
                    { name: "Nicaragua", flag: true, icon: "flags/ni.png", value: "ni" },
                    { name: "Niger", flag: true, icon: "flags/ne.png", value: "ne" },
                    { name: "Nigeria", flag: true, icon: "flags/ng.png", value: "ng" },
                    { name: "Niue", flag: true, icon: "flags/nu.png", value: "nu" },
                    { name: "Norfolk Island", flag: true, icon: "flags/nf.png", value: "nf" },
                    { name: "Northern Mariana Islands", flag: true, icon: "flags/mp.png", value: "mp" },
                    { name: "Norway", flag: true, icon: "flags/no.png", value: "no" },
                    { name: "Oman", flag: true, icon: "flags/om.png", value: "om" },
                    { name: "Pakistan", flag: true, icon: "flags/pk.png", value: "pk" },
                    { name: "Palau", flag: true, icon: "flags/pw.png", value: "pw" },
                    { name: "Palestine, State of", flag: true, icon: "flags/ps.png", value: "ps" },
                    { name: "Panama", flag: true, icon: "flags/pa.png", value: "pa" },
                    { name: "Papua New Guinea", flag: true, icon: "flags/pg.png", value: "pg" },
                    { name: "Paraguay", flag: true, icon: "flags/py.png", value: "py" },
                    { name: "Peru", flag: true, icon: "flags/pe.png", value: "pe" },
                    { name: "Philippines", flag: true, icon: "flags/ph.png", value: "ph" },
                    { name: "Pitcairn", flag: true, icon: "flags/pn.png", value: "pn" },
                    { name: "Poland", flag: true, icon: "flags/pl.png", value: "pl" },
                    { name: "Portugal", flag: true, icon: "flags/pt.png", value: "pt" },
                    { name: "Puerto Rico", flag: true, icon: "flags/pr.png", value: "pr" },
                    { name: "Qatar", flag: true, icon: "flags/qa.png", value: "qa" },
                    { name: "Réunion", flag: true, icon: "flags/re.png", value: "re" },
                    { name: "Romania", flag: true, icon: "flags/ro.png", value: "ro" },
                    { name: "Russian Federation", flag: true, icon: "flags/ru.png", value: "ru" },
                    { name: "Rwanda", flag: true, icon: "flags/rw.png", value: "rw" },
                    { name: "Saint Helena, Ascension and Tristan da Cunha", flag: true, icon: "flags/sh.png", value: "sh" },
                    { name: "Saint Kitts and Nevis", flag: true, icon: "flags/kn.png", value: "kn" },
                    { name: "Saint Lucia", flag: true, icon: "flags/lc.png", value: "lc" },
                    { name: "Saint Pierre and Miquelon", flag: true, icon: "flags/pm.png", value: "pm" },
                    { name: "Saint Vincent and the Grenadines", flag: true, icon: "flags/vc.png", value: "vc" },
                    { name: "Samoa", flag: true, icon: "flags/ws.png", value: "ws" },
                    { name: "San Marino", flag: true, icon: "flags/sm.png", value: "sm" },
                    { name: "Sao Tome and Principe", flag: true, icon: "flags/st.png", value: "st" },
                    { name: "Saudi Arabia", flag: true, icon: "flags/sa.png", value: "sa" },
                    { name: "Senegal", flag: true, icon: "flags/sn.png", value: "sn" },
                    { name: "Serbia", flag: true, icon: "flags/rs.png", value: "rs" },
                    { name: "Seychelles", flag: true, icon: "flags/sc.png", value: "sc" },
                    { name: "Sierra Leone", flag: true, icon: "flags/sl.png", value: "sl" },
                    { name: "Singapore", flag: true, icon: "flags/sg.png", value: "sg" },
                    { name: "Slovakia", flag: true, icon: "flags/sk.png", value: "sk" },
                    { name: "Slovenia", flag: true, icon: "flags/si.png", value: "si" },
                    { name: "Solomon Islands", flag: true, icon: "flags/sb.png", value: "sb" },
                    { name: "Somalia", flag: true, icon: "flags/so.png", value: "so" },
                    { name: "South Africa", flag: true, icon: "flags/za.png", value: "za" },
                    { name: "South Georgia and the South Sandwich Islands", flag: true, icon: "flags/gs.png", value: "gs" },
                    { name: "South Sudan", flag: true, icon: "flags/ss.png", value: "ss" },
                    { name: "Spain", flag: true, icon: "flags/es.png", value: "es" },
                    { name: "Sri Lanka", flag: true, icon: "flags/lk.png", value: "lk" },
                    { name: "Sudan", flag: true, icon: "flags/sd.png", value: "sd" },
                    { name: "Suriname", flag: true, icon: "flags/sr.png", value: "sr" },
                    { name: "Svalbard and Jan Mayen", flag: true, icon: "flags/sj.png", value: "sj" },
                    { name: "Sweden", flag: true, icon: "flags/se.png", value: "se" },
                    { name: "Switzerland", flag: true, icon: "flags/ch.png", value: "ch" },
                    { name: "Syrian Arab Republic", flag: true, icon: "flags/sy.png", value: "sy" },
                    { name: "Taiwan, Province of China", flag: true, icon: "flags/tw.png", value: "tw" },
                    { name: "Tajikistan", flag: true, icon: "flags/tj.png", value: "tj" },
                    { name: "Tanzania, United Republic of", flag: true, icon: "flags/tz.png", value: "tz" },
                    { name: "Thailand", flag: true, icon: "flags/th.png", value: "th" },
                    { name: "Timor-Leste", flag: true, icon: "flags/tl.png", value: "tl" },
                    { name: "Togo", flag: true, icon: "flags/tg.png", value: "tg" },
                    { name: "Tokelau", flag: true, icon: "flags/tk.png", value: "tk" },
                    { name: "Tonga", flag: true, icon: "flags/to.png", value: "to" },
                    { name: "Trinidad and Tobago", flag: true, icon: "flags/tt.png", value: "tt" },
                    { name: "Tunisia", flag: true, icon: "flags/tn.png", value: "tn" },
                    { name: "Turkey", flag: true, icon: "flags/tr.png", value: "tr" },
                    { name: "Turkmenistan", flag: true, icon: "flags/tm.png", value: "tm" },
                    { name: "Turks and Caicos Islands", flag: true, icon: "flags/tc.png", value: "tc" },
                    { name: "Tuvalu", flag: true, icon: "flags/tv.png", value: "tv" },
                    { name: "Uganda", flag: true, icon: "flags/ug.png", value: "ug" },
                    { name: "Ukraine", flag: true, icon: "flags/ua.png", value: "ua" },
                    { name: "United Arab Emirates", flag: true, icon: "flags/ae.png", value: "ae" },
                    { name: "United Kingdom", flag: true, icon: "flags/gb.png", value: "uk" },
                    { name: "United States of America", flag: true, icon: "flags/us.png", value: "us" },
                    { name: "United States Minor Outlying Islands", flag: true, icon: "flags/um.png", value: "um" },
                    { name: "Uruguay", flag: true, icon: "flags/uy.png", value: "uy" },
                    { name: "Uzbekistan", flag: true, icon: "flags/uz.png", value: "uz" },
                    { name: "Vanuatu", flag: true, icon: "flags/vu.png", value: "vu" },
                    { name: "Venezuela", flag: true, icon: "flags/ve.png", value: "ve" },
                    { name: "Viet Nam", flag: true, icon: "flags/vn.png", value: "vn" },
                    { name: "Virgin Islands, British", flag: true, icon: "flags/vg.png", value: "vg" },
                    { name: "Virgin Islands, U.S.", flag: true, icon: "flags/vi.png", value: "vi" },
                    { name: "Wallis and Futuna", flag: true, icon: "flags/wf.png", value: "wf" },
                    { name: "Western Sahara", flag: true, icon: "flags/eh.png", value: "eh" },
                    { name: "Yemen", flag: true, icon: "flags/ye.png", value: "ye" },
                    { name: "Zambia", flag: true, icon: "flags/zm.png", value: "zm" },
                    { name: "Zimbabwe", flag: true, icon: "flags/zw.png", value: "zw" }
                ],
                filetype: null,
                filetypes: {
                    popular: [
                        { name: 'pdf', icon: null, value: 'pdf' },
                        { name: 'doc', icon: null, value: 'doc' },
                        { name: 'torrent', icon: null, value: 'torrent' },
                        { name: 'jpg', icon: null, value: 'jpg' },
                        { name: 'png', icon: null, value: 'png' },
                        { name: 'gif', icon: null, value: 'gif' },
                        { name: 'ppt', icon: null, value: 'ppt' },
                        { name: 'avi', icon: null, value: 'avi' },
                        { name: 'mp3', icon: null, value: 'mp3' }
                    ],
                    audio: [
                        { name: 'aif', icon: null, value: 'aif' },
                        { name: 'cda', icon: null, value: 'cda' },
                        { name: 'mid/midi', icon: null, value: 'mid/midi' },
                        { name: 'mpa', icon: null, value: 'mpa' },
                        { name: 'mp3', icon: null, value: 'mp3' },
                        { name: 'ogg', icon: null, value: 'ogg' },
                        { name: 'wav', icon: null, value: 'wav' },
                        { name: 'wpl', icon: null, value: 'wpl' }
                    ],
                    video: [
                        { name: '3gp', icon: null, value: '3gp' },
                        { name: 'avi', icon: null, value: 'avi' },
                        { name: 'flv', icon: null, value: 'flv' },
                        { name: 'h264', icon: null, value: 'h264' },
                        { name: 'm4v', icon: null, value: 'm4v' },
                        { name: 'mkv', icon: null, value: 'mkv' },
                        { name: 'mov', icon: null, value: 'mov' },
                        { name: 'mp4', icon: null, value: 'mp4' },
                        { name: 'mpg/mpeg', icon: null, value: 'mpg/mpeg' },
                        { name: 'rm', icon: null, value: 'rm' },
                        { name: 'swf', icon: null, value: 'swf' },
                        { name: 'vob', icon: null, value: 'vob' },
                        { name: 'wmv', icon: null, value: 'wmv' }
                    ],
                    image: [
                        { name: 'ai', icon: null, value: 'ai' },
                        { name: 'bmp', icon: null, value: 'bmp' },
                        { name: 'gif', icon: null, value: 'gif' },
                        { name: 'ico', icon: null, value: 'ico' },
                        { name: 'jpg/jpeg', icon: null, value: 'jpg/jpeg' },
                        { name: 'png', icon: null, value: 'png' },
                        { name: 'ps', icon: null, value: 'ps' },
                        { name: 'psd', icon: null, value: 'psd' },
                        { name: 'svg', icon: null, value: 'svg' },
                        { name: 'tif/tiff', icon: null, value: 'tif/tiff' }
                    ],
                    text: [
                        { name: 'doc/docx', icon: null, value: 'doc/docx' },
                        { name: 'odt', icon: null, value: 'odt' },
                        { name: 'pages', icon: null, value: 'pages' },
                        { name: 'pdf', icon: null, value: 'pdf' },
                        { name: 'rtf', icon: null, value: 'rtf' },
                        { name: 'tex', icon: null, value: 'tex' },
                        { name: 'txt', icon: null, value: 'txt' },
                        { name: 'wks/wps', icon: null, value: 'wks/wps' },
                        { name: 'wpd', icon: null, value: 'wpd' }
                    ],
                    presentation: [
                        { name: 'key', icon: null, value: 'key' },
                        { name: 'odp', icon: null, value: 'odp' },
                        { name: 'pps', icon: null, value: 'pps' },
                        { name: 'ppt', icon: null, value: 'ppt' },
                        { name: 'pptx', icon: null, value: 'pptx' }
                    ],
                    spreadsheet: [
                        { name: 'ods', icon: null, value: 'ods' },
                        { name: 'xlr', icon: null, value: 'xlr' },
                        { name: 'xls', icon: null, value: 'xls' },
                        { name: 'xlsx', icon: null, value: 'xlsx' }
                    ],
                    font: [
                        { name: 'fnt', icon: null, value: 'fnt' },
                        { name: 'fon', icon: null, value: 'fon' },
                        { name: 'ttf', icon: null, value: 'ttf' },
                        { name: 'otf', icon: null, value: 'otf' }
                    ],
                    compressed: [
                        { name: '7z', icon: null, value: '7z' },
                        { name: 'arj', icon: null, value: 'arj' },
                        { name: 'deb', icon: null, value: 'deb' },
                        { name: 'pkg', icon: null, value: 'pkg' },
                        { name: 'rpm', icon: null, value: 'rpm' },
                        { name: 'tar.gz', icon: null, value: 'tar.gz' },
                        { name: 'z', icon: null, value: 'z' },
                        { name: 'zip', icon: null, value: 'zip' },
                        { name: 'rar ', icon: null, value: 'rar' }
                    ],
                    media: [
                        { name: 'bin', icon: null, value: 'bin' },
                        { name: 'dmg', icon: null, value: 'dmg' },
                        { name: 'iso', icon: null, value: 'iso' },
                        { name: 'toast', icon: null, value: 'toast' },
                        { name: 'vcd', icon: null, value: 'vcd' }
                    ],
                    data: [
                        { name: 'csv', icon: null, value: 'csv' },
                        { name: 'dat', icon: null, value: 'dat' },
                        { name: 'db/dbf', icon: null, value: 'db/dbf' },
                        { name: 'log', icon: null, value: 'log' },
                        { name: 'mdb', icon: null, value: 'mdb' },
                        { name: 'sav', icon: null, value: 'sav' },
                        { name: 'sql', icon: null, value: 'sql' },
                        { name: 'tar', icon: null, value: 'tar' },
                        { name: 'xml', icon: null, value: 'xml' }
                    ],
                    internet: [
                        { name: 'asp/aspx', icon: null, value: 'asp/aspx' },
                        { name: 'cer', icon: null, value: 'cer' },
                        { name: 'cfm', icon: null, value: 'cfm' },
                        { name: 'cgi/pl', icon: null, value: 'cgi/pl' },
                        { name: 'css', icon: null, value: 'css' },
                        { name: 'htm/html', icon: null, value: 'htm/html' },
                        { name: 'js', icon: null, value: 'js' },
                        { name: 'jsp', icon: null, value: 'jsp' },
                        { name: 'php', icon: null, value: 'php' },
                        { name: 'py', icon: null, value: 'py' },
                        { name: 'rss', icon: null, value: 'rss' },
                        { name: 'xhtml', icon: null, value: 'xhtml' }
                    ],
                    programming: [
                        { name: 'c', icon: null, value: 'c' },
                        { name: 'class', icon: null, value: 'class' },
                        { name: 'cpp', icon: null, value: 'cpp' },
                        { name: 'cs', icon: null, value: 'cs' },
                        { name: 'h', icon: null, value: 'h' },
                        { name: 'java', icon: null, value: 'java' },
                        { name: 'lua', icon: null, value: 'lua' },
                        { name: 'm', icon: null, value: 'm' },
                        { name: 'pl', icon: null, value: 'pl' },
                        { name: 'py', icon: null, value: 'py' },
                        { name: 'sh', icon: null, value: 'sh' },
                        { name: 'swift', icon: null, value: 'swift' },
                        { name: 'vb', icon: null, value: 'vb' }
                    ],
                    system: [
                        { name: 'bak', icon: null, value: 'bak' },
                        { name: 'cab', icon: null, value: 'cab' },
                        { name: 'cfg', icon: null, value: 'cfg' },
                        { name: 'cpl', icon: null, value: 'cpl' },
                        { name: 'cur', icon: null, value: 'cur' },
                        { name: 'dll', icon: null, value: 'dll' },
                        { name: 'dmp', icon: null, value: 'dmp' },
                        { name: 'drv', icon: null, value: 'drv' },
                        { name: 'icns', icon: null, value: 'icns' },
                        { name: 'ico', icon: null, value: 'ico' },
                        { name: 'ini', icon: null, value: 'ini' },
                        { name: 'lnk', icon: null, value: 'lnk' },
                        { name: 'msi', icon: null, value: 'msi' },
                        { name: 'sys', icon: null, value: 'sys' },
                        { name: 'tmp', icon: null, value: 'tmp' }
                    ],
                    executable: [
                        { name: 'apk', icon: null, value: 'apk' },
                        { name: 'bat', icon: null, value: 'bat' },
                        { name: 'bin', icon: null, value: 'bin' },
                        { name: 'cgi/pl', icon: null, value: 'cgi/pl' },
                        { name: 'com', icon: null, value: 'com' },
                        { name: 'exe', icon: null, value: 'exe' },
                        { name: 'jar', icon: null, value: 'jar' },
                        { name: 'py', icon: null, value: 'py' },
                        { name: 'wsf', icon: null, value: 'wsf' }
                    ]
                },
                filetypeSearch: '',
                //googleCustomSearchResults: '<gcse:searchresults-only gname="google-search-results"><\/gcse:searchresults-only>',
                googleTabs: {
                    'books': 'bks',
                    'finance': 'fin',
                    'images': 'isch',
                    'news': 'nws',
                    'patents': 'pts',
                    'shopping': 'shop',
                    'videos': 'vid'
                },
                language: null,
                languages: [
                    { name: "Arabic", icon: null, value: "ar" },
                    { name: "Bulgarian", icon: null, value: "bg" },
                    { name: "Catalan", icon: null, value: "ca" },
                    { name: "Chinese Simplified", icon: null, value: "zh-CN" },
                    { name: "Chinese Traditional", icon: null, value: "zh-TW" },
                    { name: "Croatian", icon: null, value: "hr" },
                    { name: "Czech", icon: null, value: "cs" },
                    { name: "Danish", icon: null, value: "da" },
                    { name: "Dutch", icon: null, value: "nl" },
                    { name: "English", icon: null, value: "en" },
                    { name: "Estonian", icon: null, value: "et" },
                    { name: "Finnish", icon: null, value: "fi" },
                    { name: "French", icon: null, value: "fr" },
                    { name: "German", icon: null, value: "de" },
                    { name: "Greek", icon: null, value: "el" },
                    { name: "Hebrew", icon: null, value: "iw" },
                    { name: "Hungarian", icon: null, value: "hu" },
                    { name: "Icelandic", icon: null, value: "is" },
                    { name: "Indonesian", icon: null, value: "id" },
                    { name: "Italian", icon: null, value: "it" },
                    { name: "Japanese", icon: null, value: "ja" },
                    { name: "Korean", icon: null, value: "ko" },
                    { name: "Latvian", icon: null, value: "lv" },
                    { name: "Lithuanian", icon: null, value: "lt" },
                    { name: "Norwegian", icon: null, value: "no" },
                    { name: "Polish", icon: null, value: "pl" },
                    { name: "Portuguese", icon: null, value: "pt" },
                    { name: "Romanian", icon: null, value: "ro" },
                    { name: "Russian", icon: null, value: "ru" },
                    { name: "Serbian", icon: null, value: "sr" },
                    { name: "Slovak", icon: null, value: "sk" },
                    { name: "Slovenian", icon: null, value: "sl" },
                    { name: "Spanish", icon: null, value: "es" },
                    { name: "Swedish", icon: null, value: "sv" },
                    { name: "Turkish", icon: null, value: "tr" }
                ],
                noneOfTheseWords: '',
                search: '',
                searchPlaceholder: 'Search web',
                searchTerm: '',
                site: '',
                thisExactPhrase: '',
                updatedAt: null,
                updatedAtValues: [
                    { name: 'anytime', icon: null, value: null },
                    { name: 'past 24 hours', icon: null, value: 'd' },
                    { name: 'past week', icon: null, value: 'w' },
                    { name: 'past month', icon: null, value: 'm' },
                    { name: 'past year', icon: null, value: 'y' }
                ],
                activeTags: [],
            }
        },
        methods: {
            changedAdvancedSearchOptions: function (e) {
                let i = 0;

                if (this.country) {
                    for (i = 0; i < this.country.length; i++) {
                        /*
                        var tagValue = this.country[i].value.split('').map(x => x.charCodeAt(0)).reduce((a, b) => a + b);
                        window.console.log(tagValue);
                        window.console.log(this.allTags.find(el => el.id === tagValue));*/
                        if (this.activeTags.find(el => el.value === this.country[i].value && el.type === 'country') === undefined) {
                            var tag = {
                                "value": this.country[i].value,//.split('').map(x => x.charCodeAt(0)).reduce((a, b) => a + b),
                                "name": this.country[i].name,
                                //"slug": "tag (optional)",
                                "color": "primary",
                                "dark": true,
                                "type": "country"
                            };
                            this.activeTags.push(tag);
                        }
                    }
                }
                if (this.language) {
                    for (i = 0; i < this.language.length; i++) {
                        if (this.activeTags.find(el => el.value === this.language[i].value && el.type === 'language') === undefined) {
                            var tag = {
                                "value": this.language[i].value,//.split('').map(x => x.charCodeAt(0)).reduce((a, b) => a + b),
                                "name": this.language[i].name,
                                //"slug": "tag (optional)",
                                "color": "primary",
                                "dark": true,
                                "type": "language"
                            };
                            this.activeTags.push(tag);
                        }

                    }
                }
                if (this.filetypeSearch || this.filetype) {
                    let filetypeArr = this.filetypeSearch.split(',');

                    for (i = 0; i < filetypeArr.length; i++) {
                        if (filetypeArr[i] != '') {
                            if (this.activeTags.find(el => el.value === filetypeArr[i] && el.type === 'filetype') === undefined) {
                                var tag = {
                                    "value": filetypeArr[i],//.split('').map(x => x.charCodeAt(0)).reduce((a, b) => a + b),
                                    "name": filetypeArr[i],
                                    //"slug": "tag (optional)",
                                    "color": "primary",
                                    "dark": true,
                                    "type": "filetype"
                                };
                                this.activeTags.push(tag);
                            }
                        }
                    }

                    if (this.filetype) {
                        for (i = 0; i < this.filetype.length; i++) {
                            if (this.activeTags.find(el => el.value === this.filetype[i].value && el.type === 'filetype') === undefined) {
                                var tag = {
                                    "value": this.filetype[i].value,//.split('').map(x => x.charCodeAt(0)).reduce((a, b) => a + b),
                                    "name": this.filetype[i].name,
                                    //"slug": "tag (optional)",
                                    "color": "primary",
                                    "dark": true,
                                    "type": "filetype"
                                };
                                this.activeTags.push(tag);
                            }
                        }
                    }
                }

                if (this.updatedAt && this.updatedAt.value) {
                    if (this.activeTags.find(el => el.value === this.updatedAt.value && el.type === 'updatedat') === undefined) {
                        var tag = {
                            "value": this.updatedAt.value,//.split('').map(x => x.charCodeAt(0)).reduce((a, b) => a + b),
                            "name": this.updatedAt.name,
                            //"slug": "tag (optional)",
                            "color": "primary",
                            "dark": true,
                            "type": "updatedat"
                        };
                        this.activeTags.push(tag);
                    }
                }
                if (this.site != '') {
                    if (this.activeTags.find(el => el.value === this.site && el.type === 'site') === undefined) {
                        var tag = {
                            "value": this.site,//.split('').map(x => x.charCodeAt(0)).reduce((a, b) => a + b),
                            "name": this.site,
                            //"slug": "tag (optional)",
                            "color": "primary",
                            "dark": true,
                            "type": "site"
                        };
                        this.activeTags.push(tag);
                    }
                }
                if (this.allTheseWords != '') {
                    if (this.activeTags.find(el => el.value === this.allTheseWords && el.type === 'allTheseWords') === undefined) {
                        var tag = {
                            "value": this.allTheseWords,//.split('').map(x => x.charCodeAt(0)).reduce((a, b) => a + b),
                            "name": this.allTheseWords,
                            //"slug": "tag (optional)",
                            "color": "primary",
                            "dark": true,
                            "type": "allTheseWords"
                        };
                        this.activeTags.push(tag);
                    }
                }
                if (this.thisExactPhrase != '') {
                    if (this.activeTags.find(el => el.value === this.thisExactPhrase && el.type === 'thisExactPhrase') === undefined) {
                        var tag = {
                            "value": this.thisExactPhrase,//.split('').map(x => x.charCodeAt(0)).reduce((a, b) => a + b),
                            "name": this.thisExactPhrase,
                            //"slug": "tag (optional)",
                            "color": "primary",
                            "dark": true,
                            "type": "thisExactPhrase"
                        };
                        this.activeTags.push(tag);
                    }
                }
                if (this.anyOfTheseWords != '') {
                    if (this.activeTags.find(el => el.value === this.anyOfTheseWords && el.type === 'anyOfTheseWords') === undefined) {
                        var tag = {
                            "value": this.anyOfTheseWords,//.split('').map(x => x.charCodeAt(0)).reduce((a, b) => a + b),
                            "name": this.anyOfTheseWords,
                            //"slug": "tag (optional)",
                            "color": "primary",
                            "dark": true,
                            "type": "anyOfTheseWords"
                        };
                        this.activeTags.push(tag);
                    }
                }
                if (this.noneOfTheseWords != '') {
                    if (this.activeTags.find(el => el.value === this.noneOfTheseWords && el.type === 'noneOfTheseWords') === undefined) {
                        var tag = {
                            "value": this.noneOfTheseWords,//.split('').map(x => x.charCodeAt(0)).reduce((a, b) => a + b),
                            "name": this.noneOfTheseWords,
                            //"slug": "tag (optional)",
                            "color": "primary",
                            "dark": true,
                            "type": "noneOfTheseWords"
                        };
                        this.activeTags.push(tag);
                    }
                }

                for (i = this.activeTags.length - 1; i >= 0; i--) {
                    if (this.activeTags[i].type === 'country' && (this.country === null || this.country.find(x => x.value === this.activeTags[i].value) === undefined)) {
                        this.activeTags.splice(i, 1);
                        continue;
                    }
                    if (this.activeTags[i].type === 'language' && (this.language === null || this.language.find(x => x.value === this.activeTags[i].value) === undefined)) {
                        this.activeTags.splice(i, 1);
                        continue;
                    }
                    if (this.activeTags[i].type === 'filetype') {
                        let filetypeArr = this.filetypeSearch.split(',');
                        if (filetypeArr.find(x => x === this.activeTags[i].value) === undefined && (this.filetype === null || this.filetype.find(x => x.value === this.activeTags[i].value) === undefined)) {
                            this.activeTags.splice(i, 1);
                            continue;
                        }
                    }
                    if (this.activeTags[i].type === 'updatedat' && this.updatedAt.value !== this.activeTags[i].value) {
                        this.activeTags.splice(i, 1);
                        continue;
                    }
                    if (this.activeTags[i].type === 'site' && this.site !== this.activeTags[i].value) {
                        this.activeTags.splice(i, 1);
                        continue;
                    }
                    if (this.activeTags[i].type === 'allTheseWords' && this.allTheseWords !== this.activeTags[i].value) {
                        this.activeTags.splice(i, 1);
                        continue;
                    }
                    if (this.activeTags[i].type === 'thisExactPhrase' && this.thisExactPhrase !== this.activeTags[i].value) {
                        this.activeTags.splice(i, 1);
                        continue;
                    }
                    if (this.activeTags[i].type === 'anyOfTheseWords' && this.anyOfTheseWords !== this.activeTags[i].value) {
                        this.activeTags.splice(i, 1);
                        continue;
                    }
                    if (this.activeTags[i].type === 'noneOfTheseWords' && this.noneOfTheseWords !== this.activeTags[i].value) {
                        this.activeTags.splice(i, 1);
                        continue;
                    }
                }
            },
            getQueryParam: function (name, url) {
                if (!url) url = location.href;

                name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");

                let regexS = "[\\?&]" + name + "=([^&#]*)";
                let regex = new RegExp(regexS);
                let results = regex.exec(url);
                return results == null ? null : results[1];
            },
            handleReset: function () {
                this.country = null;
                this.language = null;
                this.filetype = null;
                this.filetypeSearch = '';
                this.updatedAt = null;
                this.site = '';
                this.allTheseWords = '';
                this.thisExactPhrase = '';
                this.anyOfTheseWords = '';
                this.noneOfTheseWords = '';
                this.search = '';
                this.searchTerm = '';

                this.activeTags = [];

                eventBus.$emit('selector-reset');
            },
            handleSubmit: function (e) {
                eventBus.$emit('show-loader');

                /*if (this.activeTab == 'news') {
                    var url = 'https://www.google.com/' + (this.activeTab == 'maps' ? 'maps' : 'search') + '?q=' + this.search + '&tbm=' + this.googleTabs[this.activeTab];

                    let queryObj = { q: this.search, url: url };

                    let sameRoute = (this.$route.name === 'advanced-search');
                    this.$router.push({
                        name: 'advanced-search',
                        query: queryObj
                    });
                    if (sameRoute)
                        eventBus.$emit('bbrc-as-fr');

                    eventBus.$emit('hide-loader');
                } else */
                if (this.activeTab != 'search') {
                    var url = '';
                    if (this.activeTab == 'scholar') {
                        url = 'https://scholar.google.com/scholar?q=' + this.search;
                    } else if (this.activeTab == 'flights') {
                        url = 'https://www.google.com/flights?q=' + this.search;
                    }
                    else {
                        url = 'https://www.google.com/' + (this.activeTab == 'maps' ? 'maps' : 'search') + '?q=' + this.search + '&tbm=' + this.googleTabs[this.activeTab];
                    }
                    var win = window.open(url, '_blank');
                    win.focus();

                    eventBus.$emit('hide-loader');
                } else {
                    let i = 0;

                    let queryObj = { q: this.search };
                    if (this.country && this.country.length > 0) {
                        queryObj.country = '';
                        for (i = 0; i < this.country.length; i++)
                            queryObj.country += ',' + this.country[i].value;
                        queryObj.country = queryObj.country.substring(1);
                    }
                    if (this.language && this.language.length > 0) {
                        queryObj.language = '';
                        for (i = 0; i < this.language.length; i++)
                            queryObj.language += ',' + this.language[i].value;
                        queryObj.language = queryObj.language.substring(1);
                    }
                    if (this.filetype && this.filetype.length > 0) {
                        queryObj.filetype = '';
                        for (i = 0; i < this.filetype.length; i++)
                            queryObj.filetype += ',' + this.filetype[i].value;
                        queryObj.filetype = queryObj.filetype.substring(1);
                    }
                    if (this.filetypeSearch !== '')
                        queryObj.filetypeSearch = this.filetypeSearch;
                    if (this.updatedAt && this.updatedAt.value)
                        queryObj.updatedAt = this.updatedAt.value;
                    if (this.site !== '')
                        queryObj.site = this.site;
                    if (this.allTheseWords !== '')
                        queryObj.allTheseWords = this.allTheseWords;
                    if (this.thisExactPhrase !== '')
                        queryObj.thisExactPhrase = this.thisExactPhrase;
                    if (this.anyOfTheseWords !== '')
                        queryObj.anyOfTheseWords = this.anyOfTheseWords;
                    if (this.noneOfTheseWords !== '')
                        queryObj.noneOfTheseWords = this.noneOfTheseWords;

                    this.$router.push({ name: 'advanced-search', query: queryObj });
                    let sameRoute = (this.$route.name === 'advanced-search');
                    if (sameRoute)
                        eventBus.$emit('bbrc-as-fr', queryObj);
                    /*
                    else
                        this.$router.push({ name: 'advanced-search', query: queryObj });
                    */
                }

                this.$parent.isOpen = false;

                eventBus.$emit('hide-loader');
            },
            init: function () {
                ///*(function() {
                //    var cx = '009275257355941826566:spomlbkmlfa';
                //    var gcse = document.createElement('script');
                //    gcse.type = 'text/javascript';
                //    gcse.async = true;
                //    gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
                //    var s = document.getElementsByTagName('script')[0];
                //    s.parentNode.insertBefore(gcse, s);
                //})();*/
                /*(function () {
                    var cx = '011709633724337717639:cty_ncq8qou';
                    var gcse = document.createElement('script');
                    gcse.type = 'text/javascript';
                    gcse.async = true;
                    gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
                    var s = document.getElementsByTagName('script')[0];
                    s.parentNode.insertBefore(gcse, s);
                })();*/

                this.search = this.getQueryParam('q');                
                if (this.search)
                    this.search = decodeURIComponent(this.search.replace(/\+/g,  " "));

                let str = this.getQueryParam('country');
                let arr = [];
                let i = 0;
                let j = 0;
                if (str) {
                    arr = str.split(',');
                    this.country = [];
                    for (i = 0; i < arr.length; i++)
                        for (j = 0; j < this.countries.length; j++)
                            if (arr[i] == this.countries[j].value) {
                                //this.$children[0].setValue(this.countries[j]);
                                this.country.push(this.countries[j]);
                                break;
                            }
                }

                str = this.getQueryParam('language');
                if (str) {
                    arr = str.split(',');
                    this.language = [];
                    for (i = 0; i < arr.length; i++)
                        for (j = 0; j < this.languages.length; j++)
                            if (arr[i] == this.languages[j].value) {
                                //this.$children[1].setValue(this.languages[j]);
                                this.language.push(this.languages[j]);
                                break;
                            }
                }

                str = this.getQueryParam('filetype');
                if (str) {
                    arr = str.split(',');
                    this.filetype = [];
                    let ftProps = Object.keys(this.filetypes);
                    let p = 0;
                    let found = false;
                    for (i = 0; i < arr.length; i++) {
                        for (p = 0; p < ftProps.length; p++) {
                            found = false;
                            for (j = 0; j < this.filetypes[ftProps[p]].length; j++)
                                if (arr[i] == this.filetypes[ftProps[p]][j].value) {
                                    //this.$children[1].setValue(this.filetypes.popular[j]);
                                    this.filetype.push(this.filetypes[ftProps[p]][j]);
                                    found = true;
                                    break;
                                }
                            if (found)
                                break;
                        }
                    }
                }
                str = this.getQueryParam('filetypeSearch');
                if (str && str !== '')
                    this.filetypeSearch = str;
                str = this.getQueryParam('updatedAt');
                if (str) {
                    for (j = 0; j < this.updatedAtValues.length; j++)
                        if (str == this.updatedAtValues[j].value) {
                            //this.$children[3].setValue(this.updatedAtValues[j]);
                            this.updatedAt = this.updatedAtValues[j];
                            break;
                        }
                }
                str = this.getQueryParam('site');
                if (str && str !== '')
                    this.site = str;
                str = this.getQueryParam('allTheseWords');
                if (str && str !== '')
                    this.allTheseWords = str;
                str = this.getQueryParam('thisExactPhrase');
                if (str && str !== '')
                    this.thisExactPhrase = str;
                str = this.getQueryParam('anyOfTheseWords');
                if (str && str !== '')
                    this.anyOfTheseWords = str;
                str = this.getQueryParam('noneOfTheseWords');
                if (str && str !== '')
                    this.noneOfTheseWords = str;

                //this.changedAdvancedSearchOptions(null);
            },
            scrollToResults: function () {
                let resultsElement = document.getElementById('search-results');
                if (resultsElement) {
                    resultsElement.scrollIntoView({
                        block: "start",
                        behavior: "smooth"
                    });
                }
            },
            switchFileTypeTab: function (tab) {
                this.activeFileTypeTab = tab;
            },
            switchOptionTab: function (tab) {
                this.activeOptionTab = tab;
            },
            switchTab: function (tab) {
                this.activeTab = tab;

                switch (tab) {
                    case 'search':
                        this.searchPlaceholder = 'Search web';
                        break;
                    case 'maps':
                        this.searchPlaceholder = 'Search on Google Maps';
                        break;
                    default:
                        this.searchPlaceholder = 'Search for ' + tab;

                }
            },
            onTagRemoved: function (index) {
                let i = 0;
                if (this.activeTags[index].type === 'country' && this.country != null)
                    for (i = this.country.length - 1; i >= 0; i--)
                        if (this.country[i].value === this.activeTags[index].value) {
                            this.country.splice(i, 1);
                            break;
                        }
                if (this.activeTags[index].type === 'language' && this.language != null)
                    for (i = this.language.length - 1; i >= 0; i--)
                        if (this.language[i].value === this.activeTags[index].value) {
                            this.language.splice(i, 1);
                            break;
                        }
                if (this.activeTags[index].type === 'filetype' && this.filetype != null) {
                    for (i = this.filetype.length - 1; i >= 0; i--)
                        if (this.filetype[i].value === this.activeTags[index].value) {
                            this.filetype.splice(i, 1);
                            break;
                        }

                    let filetypeArr = this.filetypeSearch.split(',');
                    for (i = filetypeArr.length - 1; i >= 0; i--)
                        if (filetypeArr[i] === this.activeTags[index].value) {
                            filetypeArr.splice(i, 1);
                            break;
                        }
                    this.filetypeSearch = filetypeArr.join(',');
                }
                if (this.activeTags[index].type === 'updatedat')
                    this.updatedAt = null;
                if (this.activeTags[index].type === 'site')
                    this.site = '';
                if (this.activeTags[index].type === 'allTheseWords')
                    this.allTheseWords = '';
                if (this.activeTags[index].type === 'thisExactPhrase')
                    this.thisExactPhrase = '';
                if (this.activeTags[index].type === 'anyOfTheseWords')
                    this.anyOfTheseWords = '';
                if (this.activeTags[index].type === 'noneOfTheseWords')
                    this.noneOfTheseWords = '';

                this.activeTags.splice(index, 1);

                //if (this.activeTags.length === 0)
                //    this.handleReset();
                //else
                //    this.handleSubmit();
            }
        },
        props: {
            type: {
                default: null,
                type: String
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/BbrcAdvancedSearch.vue